<template>
  <div class="notice-box">
    <van-sticky
      class="sticky-bar"
      v-if="globalNotice && globalNotice.content"
      :offset-top="top || getNoticeTop"
    >
      <van-notice-bar
        @click="handleNotice(1)"
        left-icon="volume-o"
        :text="globalNotice.title"
      />
    </van-sticky>
    <van-popup
      :close-on-click-overlay="false"
      v-if="globalNotice"
      v-model="show"
      position="top"
      :style="{ top: getPopupTop + 'px' }"
    >
      <div class="notice-title" v-html="globalNotice.title"></div>
      <div class="notice-date">{{ globalNotice.up_time | dateFormat }}</div>
      <div class="notice-content" v-html="globalNotice.content"></div>
      <div class="notice-ok-btn" @click="handleNotice(2)">
        {{ $t("im.我知道了") }}
        {{ timeNum && timeNum > 0 ? `(${timeNum})` : null }}
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "GlobalNotice",
  props: {
    top: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      show: false,
      timeNum: 0,
      timer: null,
    };
  },
  computed: {
    ...mapGetters(["globalNotice"]),
    getNoticeTop() {
      let height =
        (document.getElementsByClassName("nav-bar")[0] &&
          document.getElementsByClassName("nav-bar")[0].offsetHeight) ||
        44;
      return height;
    },
    getPopupTop() {
      let height =
        (document.getElementsByClassName("nav-bar")[0] &&
          document.getElementsByClassName("nav-bar")[0].offsetHeight) ||
        44;
      return height;
    },
  },
  mounted() {},
  methods: {
    handleNotice(type) {
      if (type === 1) {
        this.show = true;
        const timeNum = (this.globalNotice && this.globalNotice.wait_time) || 0;
        this.timeNum = timeNum;
        if (timeNum && timeNum > 0) {
          this.setTimer();
        }
      } else {
        if (this.timeNum && this.timeNum > 0) {
          return;
        }
        this.show = false;
      }
    },
    setTimer() {
      this.timer = setInterval(() => {
        this.timeNum = this.timeNum - 1;
        if (this.timeNum <= 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
.notice-box {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  .sticky-bar {
    width: 100%;
    /deep/ .van-notice-bar__content {
      width: 100%;
    }
  }
  .notice-title {
    font-size: 16px;
    padding: 10px;
  }

  .notice-date {
    padding: 0 10px;
    color: #999;
    font-size: 12px;
  }

  .notice-content {
    padding: 10px;
    color: #666;
    font-size: 14px;
    height: 25vh;
    .scrollMinXin(hidden, auto);
  }

  .notice-ok-btn {
    width: 100%;
    height: 40px;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #f7f7f7;
    color: @gold;
  }
}
</style>
